import { polymorphic } from '../../utils/index.js';
export const DialogTitleBarTitle = polymorphic.div('iui-dialog-title');
DialogTitleBarTitle.displayName = 'Dialog.TitleBar.Title';
